import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import FormControlLabel from '@mui/material/FormControlLabel';
import RadioGroup from '@mui/material/RadioGroup';
import Radio from '@mui/material/Radio';
import Button from '@mui/material/Button';
import FormHelperText from '@mui/material/FormHelperText';

import useGlobalStatus from '../../../hook/useGlobalStatus';

import { PAGE } from '../../../constants/url';

import theme from '../../../theme';

import { TextFieldWhite, SpanError } from '../../../components/customStyles/form';
import { MODAL_CONTENT } from '../../../components/modal/constants';

import { GENERATION_FORM_ERROR_MSG } from '../constants';

import { FormTitle } from './generationFormStyle';


const ProductSelection = (props) => {
  const { generationForm, productType, setProductType, inputErrorMsg, progress } = props;
  const { setIsModalOpen, setModalContent } = useGlobalStatus();
  const navigate = useNavigate();

  const handleProductTypeChange = (e) => {
    setProductType(e.target.value);
  }

  const handleDeleteGenerationForm = () => {
    setIsModalOpen(true);
    setModalContent(MODAL_CONTENT['clearFormSettings']);
  }

  return (
    <Box mb={5} width="100%">
      <Stack variant="between-center">
        <FormTitle variant='h4'>選擇商品<SpanError>*</SpanError></FormTitle>
        <Button
          variant='text-grey-sm'
          disabled={(!productType || progress) ? true : false}
          onClick={handleDeleteGenerationForm}
          sx={{
            '&:disabled': {
              color: theme.palette.grey.w200,
              backgroundColor: 'inherit',
            }
          }}
        >
          清空設定
        </Button>
      </Stack>
      <Box mt={2}>
        <RadioGroup
          name="product-radio-group"
          value={productType}
          disabled={progress}
          onChange={handleProductTypeChange}
        >
          <Box>
            <FormControlLabel
              value="selectProductList"
              control={<Radio disabled={progress} />}
              label=""
            />
            <Button
              variant='fill-main-sm'
              disabled={progress}
              onClick={() => navigate(PAGE.productList.path)}
            >
              從商品列表中選擇
            </Button>
            {inputErrorMsg?.selectProduct &&
              <FormHelperText error>{GENERATION_FORM_ERROR_MSG.selectProduct}</FormHelperText>
            }
            {generationForm.product_title &&
              <Box mt={1}>
                <TextFieldWhite
                  name="productTitle"
                  placeholder="商品標題"
                  fullWidth
                  value={generationForm.product_title || "--"}
                  disabled={true}
                />
              </Box>
            }
          </Box>

          <Box mt={1}>
            <FormControlLabel
              value="customProduct"
              control={<Radio disabled={progress} />}
              label="自定義商品"
              componentsProps={{ typography: { style: { marginLeft: '12px' } } }}
            />
          </Box>
        </RadioGroup>
      </Box>
    </Box>
  )
}

export default ProductSelection;